var map = {
	"./es-AR.json": [
		3701,
		3701
	],
	"./es-PE.json": [
		3246,
		3246
	],
	"./es-UY.json": [
		3895,
		3895
	],
	"./resources/es-AR/localidades.json": [
		1324,
		1324
	],
	"./resources/es-AR/provincias.json": [
		8727,
		6962
	],
	"./resources/es-PE/departamentos.json": [
		9980,
		9980
	],
	"./resources/es-PE/distritos.json": [
		6195,
		6195
	],
	"./resources/es-PE/provincias.json": [
		8044,
		8044
	],
	"./resources/es-PE/ubigeos.json": [
		7728,
		7728
	],
	"./resources/es-UY/localidades.json": [
		9720,
		9720
	],
	"./resources/es-UY/provincias.json": [
		1185,
		1185
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 1539;
module.exports = webpackAsyncContext;